import Vue from 'vue'
// import moment from 'moment'
import format from 'date-fns/format'
// 自定义过滤器
Vue.filter('date-format', function(value, formatStr = 'YYYY-MM-DD HH:mm:ss') {
  // return moment(value).format(formatStr)
  return format(value, formatStr)
})

Vue.filter('book-show-name', function(showName) {
  return showName.replace('英语（三年级起点）', '')
    .replace('英语（一年级起点）', '')
    .replace('英语', '')
    .replace(/[（|(]供高中.{1}年级.{1}学期使用[）|)]/g, '')
    .replace('学生用书', '')
})



// WEBPACK FOOTER //
// ./src/filters/index.js